<template>
  <div>
    <Button class="button" @click="handleClick">
      <v-ons-row>
        <v-ons-col class="image-area" vertical-align="center">
          <img v-if="image" class="image" :src="image" :alt="alt" />
        </v-ons-col>
        <v-ons-col class="text-area-wrapper">
          <div class="text-area">
            <p class="title">{{ title }}</p>
            <p class="description">{{ description }}</p>
          </div>
        </v-ons-col>
      </v-ons-row>
    </Button>
  </div>
</template>

<script setup>
import Button from '@/components/common/Button.vue';

// プロパティの定義
defineProps({
  title: {
    type: String,
    required: true,
  },
  description: {
    type: String,
    required: true,
  },
  image: {
    type: String,
    default: null,
  },
  alt: {
    type: String,
    default: '',
  },
});

// クリックイベントを定義
const emit = defineEmits(['click']);

// クリックイベントハンドラ
const handleClick = () => {
  emit('click');
};
</script>

<style scoped>
.button {
  background-color: white;
  border: solid 0.2rem #dddddd;
  box-shadow: 0.2rem 0.2rem 0.2rem #dddddd;
}
.title {
  color: black;
  font-size: 1.5rem;
  font-weight: bold;
  margin: 0;
}
.description {
  color: black;
  font-size: 1.3rem;
  line-height: 1.5rem;
  margin: 0;
  width: 100%;
  white-space: pre-line;
}
.image {
  box-sizing: border-box;
  height: 11rem;
  padding: 2rem;
  object-fit: contain;
  vertical-align: middle;
}
.text-area {
  box-sizing: border-box;
  height: 100%;
  padding: 5% 0;
  text-align: left;
  width: 100%;
}
.image-area {
  flex-grow: 0;
  width: fit-content;
  height: fit-content;
}
.text-area-wrapper {
  flex-grow: 1;
}
</style>
